import { skills } from "./constants";
import { EachSkill, SkillImage, SkillText, SkillsBox, SkillsContainer, SkillsText } from "./styles";
export default function Skills() {

    return (
        <SkillsBox id="SKILLS">
            <SkillsText>SKILLS</SkillsText>
            <SkillsContainer>
                {skills.map((eachSkill, index) => {
                    return <EachSkill key={index}>
                        <SkillImage src={eachSkill.src} alt={eachSkill.name} />
                        <SkillText>{eachSkill.name}</SkillText>
                    </EachSkill>
                })}
            </SkillsContainer>
        </SkillsBox>
    );
}